import React, { useState, useEffect } from "react";
import "./style.css";

import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import estelas_rosas from "../../../../../assets/imgs/amc-domestico/Estelas_AMC.svg";
import axios from "axios";

const ReceptionCollection = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [turnsLeft, setTurnsLeft] = useState([]);
  const [turnsRight, setTurnsRight] = useState([]);
  const [callTurns, setCallTurns] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const getLetfTurns = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/supervisor/left_screen`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      setTurnsLeft(response.data.data.turns);
    } catch (error) {
      console.error("error", error);
    }
  };

  const getRightTurns = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/supervisor/right_screen`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      const turnsInProgress = response.data?.data?.turns_in_progress || [];
      const turnInProgress = response.data?.data?.turn_in_progress;

      // Ordenar los turnos por fecha ascendente (del más antiguo al más reciente)
      const sortedTurns = [...turnsInProgress].sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });

      // Tomar los primeros 6 ya ordenados
      const firstSixTurns = sortedTurns.slice(0, 6);

      // Verificar si el turno en progreso es válido y agregarlo al final con la marca 'inProgress'
      if (
        turnInProgress &&
        turnInProgress.turn_number &&
        turnInProgress.turn_number !== "-"
      ) {
        firstSixTurns.push({
          ...turnInProgress,
          inProgress: true,
        });
      }

      // Asignar al estado
      setTurnsRight(firstSixTurns);
    } catch (error) {
      console.error("Error al obtener turnos en pantalla derecha:", error);
    }
  };

  const extractHourMinutes = (dateString) => {
    if (!dateString) return "";

    const parts = dateString.split(" ");
    if (parts.length !== 2) return "";

    const time = parts[1];
    const [hours, minutes] = time.split(":");

    return `${hours}:${minutes}`;
  };

  const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  };

  const getTurnsVoice = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/supervisor/turn_scream`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        const newTurns = res.data.data.turns;
        if (callTurns.length === 0 || !arraysAreEqual(callTurns, newTurns)) {
          setCallTurns(newTurns);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deletedTurnsVoice = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/supervisor/turn_scream/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const waitForVoices = () => {
    return new Promise((resolve) => {
      const voices = speechSynthesis.getVoices();
      if (voices.length > 0) {
        return resolve(voices);
      }

      console.log("🔄 Esperando que se carguen las voces...");

      const interval = setInterval(() => {
        const updatedVoices = speechSynthesis.getVoices();
        if (updatedVoices.length > 0) {
          clearInterval(interval);
          resolve(updatedVoices);
        }
      }, 100);
    });
  };

  const handleTextToSpeech = async (text) => {
    if (!text.trim()) {
      console.warn("⚠️ Texto vacío, se omite.");
      return;
    }

    console.log("🔊 Iniciando texto a voz:", text);

    // Cancelar cualquier voz anterior
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "es-MX"; // preferencia regional

    const voices = await waitForVoices();

    // Preferencia de voz: Raul (es-MX), cualquier es-MX, fallback a la primera disponible
    const defaultVoice =
      voices.find((v) => v.lang === "es-MX" && v.name.includes("Raul")) ||
      voices.find((v) => v.lang === "es-MX") ||
      voices[0];

    if (!defaultVoice) {
      console.error("❌ No se encontró una voz adecuada.");
      return;
    }

    utterance.voice = defaultVoice;

    return new Promise((resolve) => {
      utterance.onstart = () => console.log("▶️ Comenzó a hablar...");
      utterance.onend = () => {
        console.log("✅ Terminó de hablar.");
        resolve();
      };
      utterance.onerror = (e) => {
        console.error("❌ Error en voz:", e.error);
        resolve(); // No romper flujo
      };

      try {
        console.log(
          `🗣️ Usando voz: ${defaultVoice.name} (${defaultVoice.lang})`
        );
        window.speechSynthesis.speak(utterance);
      } catch (e) {
        console.error("❌ Excepción al hablar:", e);
        resolve();
      }
    });
  };

  useEffect(() => {
    getLetfTurns();

    const interval = setInterval(getLetfTurns, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getRightTurns();

    const interval = setInterval(getRightTurns, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(getTurnsVoice, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const processTurns = async () => {
      console.log("🚦 Procesando turnos para vocear:", callTurns);
      if (isProcessing) return;
      setIsProcessing(true);

      for (const turn of callTurns) {
        try {
          const number = parseInt(turn.turn_number, 10).toString();
          const message = `Turno ${number} por favor dirigirse a ${turn.counter_checkout_name}`;

          console.log("📢 Llamando turno:", message);

          await handleTextToSpeech(message);

          const deleteSuccess = await deletedTurnsVoice(turn.id);
          if (deleteSuccess) {
            console.log(`🗑️ Turno ${turn.id} eliminado exitosamente`);
            setCallTurns((prevTurns) =>
              prevTurns.filter((t) => t.id !== turn.id)
            );
          } else {
            console.error(`❌ Error al eliminar el turno con ID: ${turn.id}`);
          }
        } catch (error) {
          console.error(`❌ Error procesando turno ${turn.id}:`, error);
        }
      }

      setIsProcessing(false);
    };

    if (callTurns.length > 0 && !isProcessing) {
      processTurns();
    }
  }, [callTurns, isProcessing]);

  return (
    <>
      <div className="reception-container-rc">
        <div className="reception-header">
          <div className="header-image">
            <div className="left">
              <img src={amc_logo} alt="amc-logo" />
            </div>
            <div className="right">
              <img src={estelas_rosas} className="estelas" alt="estelas" />
            </div>
          </div>
          <div className="header-hours">
            <span>{currentDate}</span>
            <span>{currentTime}</span>
          </div>
        </div>
        <div className="reception-body">
          <div className="body-left">
            <div className="title">
              <h1>Mercancia lista para salida</h1>
            </div>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Turno</th>
                    <th className="one-line">Hora Listo Salidas</th>
                  </tr>
                </thead>
                <tbody>
                  {turnsLeft.length > 0
                    ? turnsLeft.slice(0, 7).map((turn) => (
                        <tr>
                          <td>{turn.turn_number}</td>
                          <td>{extractHourMinutes(turn.date)}</td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
          <div className="body-right">
            <div className="title">
              <h1>Turnos en mostrador</h1>
            </div>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Turno</th>
                    <th>Mostrador</th>
                    <th>Hora atención</th>
                  </tr>
                </thead>
                <tbody>
                  {turnsRight.length > 0
                    ? turnsRight.slice(0, 7).map((turn) => (
                        <tr>
                          <td className={turn.inProgress ? "last" : ""}>
                            {turn.turn_number}
                          </td>
                          <td className={turn.inProgress ? "last" : ""}>
                            {turn.counter_checkout_name}
                          </td>
                          <td className={turn.inProgress ? "last" : ""}>
                            {extractHourMinutes(turn.date)}
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceptionCollection;
